import CustomModal from '../../../../components/Modal/CustomModal';
import { ATTENDANCES_TABS_MODEL } from '../Model/Model';
import { CustomSelectAndChildren } from '../../../../components/CustomSelectAndChildren';
import NotInformation from '../../../../components/NotInformation';
import { MenuItem } from '@mui/material';
import AddUserTypeModalApp from '../Functionality/AddUserTypeModal';
import CustomAddChipSearch from '../../../../components/CustomAddChipSearch';
import { TABLES } from '../../../../Apis/Tables';
import { SERVICE_ADVANCED_SEARCH } from '../../../../reduxToolkit/Commons/CommonsApi';
import {userListToLabelEmailPhoneValue} from "../../../../Apis/functions";
import {PersonChipBlack} from "../../../../components/buttons/IconButtons";
import {getVisitorTypeName} from "../../Visitor/Type/Model/Model";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const AddUserTypeModal = (props) => {
    const { show, onHide, activeTab, setShowVisitorModal, setModified, setSearchElement, userList, setUserList } = props;
    const {
        modalTitleKey,
        t,
        visitorType,
        setVisitorType,
        permissionVisitors,
        visitorTypes,
        emptyFields,
        onConfirm
    } = AddUserTypeModalApp({
        show,
        onHide,
        activeTab,
        setShowVisitorModal,
        setModified,
        setSearchElement,
        userList,
        setUserList
    });

    return (
        <CustomModal
            show={show}
            onHide={() => {
                setUserList([]);
                onHide();
            }}
            size='md'
            buttonConfirm='confirm'
            onConfirm={onConfirm}
            classNameBody="pt-2"
        >
            <div className='d-flex justify-content-center align-items-center'>
                <p className='fs-24px font-color-general-950 ibl-font-w-600'> {t(modalTitleKey)}</p>
            </div>
            <div className='my-4'>
                <CustomAddChipSearch
                    autocompleteId='slt_autm_user'
                    buttonId='btn_autm_user'
                    label='search_by_name_email_or_phone'
                    required={true}
                    selectedList={userList}
                    setSelectedList={setUserList}
                    userTypeIdsSearch={[activeTab]}
                    api={SERVICE_ADVANCED_SEARCH}
                    model={TABLES.USER_BY_USER_TYPE}
                    rowsPerPage={20}
                    showRenderOption={true}
                    hideButton={true}
                    noOptionsCard={
                        activeTab === ATTENDANCES_TABS_MODEL.VISITOR.id ?
                            <NotInformation
                                card={false}
                                text={t('we_could_not_find_your_profile')}
                                showButton={ permissionVisitors}
                                buttonId='btn_autm_link_create'
                                buttonOnclick={() => setShowVisitorModal(true)}
                                buttonTrans='add_visitor'
                            /> : null
                    }
                    emptyFields={emptyFields}
                    reset={false}
                    keyId={"userId"}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                />

                {activeTab === ATTENDANCES_TABS_MODEL.VISITOR.id && (
                    <CustomSelectAndChildren
                        id='slt_autm_visitor_type'
                        name='visitorType'
                        value={visitorType}
                        onChange={(e) => setVisitorType(e.target.value)}
                        trans='visitor_type'
                        label='lbl_autm_visitor_type'
                        required={true}
                        showNoSelectionOption={false}
                        emptyFields={emptyFields}
                    >
                        {visitorTypes?.map((item) => (
                            <MenuItem key={item.id} value={item.id}>{getVisitorTypeName(t, item.name)}</MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                )}
            </div>
        </CustomModal>
    );
};

export default AddUserTypeModal;
